/**
 * 格式化数字为货币千分位
 *
 * @param value 数字
 */
export const formatMoney = (value: number, decimals?: number) => {
  const parts = value?.toFixed?.(decimals != null ? decimals : (decimals = 2)).split('.');
  const integerPart = parts?.[0]?.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

  return integerPart + (decimals ? '.' + parts[1] : '');
};

// 单位
export function formatMoneyWithUnit(value, fix = 3) {
  const num = Number(value);
  if (!Number.isFinite(num)) return '--';
  const abs = Math.abs(num);
  const sign = num < 0 ? '-' : '';
  const trimZero = (s) => s.replace(/\.?0+$/, ''); // 可选：10.00万 → 10万
  if (abs >= 1e12) {
    const v = abs / 1e12;
    return sign + trimZero(v.toFixed(2)) + '万亿';
  }
  if (abs >= 1e8) {
    const v = abs / 1e8;
    return sign + trimZero(v.toFixed(2)) + '亿';
  }
  if (abs >= 1e4) {
    const v = abs / 1e4;
    return sign + trimZero(v.toFixed(2)) + '万';
  }
  return formatMoney(num, fix);
}

export const getNumK = (num: number | string): string => {
  const n = +num;
  if (isNaN(n)) return String(num);
  const abs = Math.abs(n);
  const sign = n < 0 ? '-' : '';
  if (abs >= 1_0000_0000) return `${sign}${(abs / 1_0000_0000).toFixed(1)}B`;
  if (abs >= 1_0000) return `${sign}${(abs / 1_0000).toFixed(1)}W`;
  if (abs >= 1000) return `${sign}${(abs / 1000).toFixed(1)}K`;
  return String(n);
};
